// extracted by mini-css-extract-plugin
module.exports = {"project-card":"ProjectCard_project-card__1RACt","title":"ProjectCard_title__1qSeV","content":"ProjectCard_content__2-PXx"};